import { StickyNote2Outlined } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { theme } from 'theme/theme';
import { datosFormEmail } from 'utils/formData';
import Formulario from '../Formulario/Formulario';
import { useError } from 'services/ErrorContext';
import { IFormulario } from 'utils/models/interfaces';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './SuscripcionBoletin.scss';
import { useState } from 'react';
import { suscripcionBoletin } from 'services/servicioPost';
import Alerta from '../Alerta.tsx/Alerta';

const SuscripcionBoletin = () => {
  const { error, setError, clearError, loading, setLoading } = useError();
  const [mensajeExito, setMensajeExito] = useState('');

  const tituloSuscripcion = '¡Suscribite para enterarte de los espectáculos!';

  async function handleSubmit(data: IFormulario): Promise<void> {
    clearError();

    const emailSuscripto = data.email || 'No ingresado';
    const request = { id: 0, email: emailSuscripto };

    try {
      await suscripcionBoletin(request, setError, setLoading);
      setMensajeExito('¡Gracias por suscribirte a nuestro Newsletter!');
    } catch (err) {
      // El error ya se manejó en setError de postData
    }
  }

  return (
    <>
      <Alerta
        mensaje={error ? error : mensajeExito}
        abierto={!!mensajeExito || !!error}
        severity={error ? 'error' : 'success'}
      />
      <Accordion
        sx={{
          mb: '226px!important',
          mt: '-230px!important',
          backgroundColor: theme.palette.primary.dark,
          pl: { lg: 2, xl: 0 },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />} className="accordionSummary">
          <Typography variant="h6" fontSize={'1rem'} textAlign="center" color="white">
            {tituloSuscripcion}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ marginTop: '-60px' }}>
          <Box display="flex" justifyContent="center" pb={2} width="100%" mx="auto" pt={3}>
            {/* La desuscripción debe estar en el formulario de edición de datos de cada usuario, con un checkbox: "Deseo dejar de recibir boletines" */}
            <Formulario
              campos={datosFormEmail}
              anchoMax={400}
              variante="oscuro"
              onSubmit={handleSubmit}
              mensajeExito={mensajeExito}
              mensajeError={error}
              loading={loading}
              iconoBoton={StickyNote2Outlined}
              textoBoton="Suscribirme"
            />
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default SuscripcionBoletin;
